import {MENU_CLOSED, MENU_OPEN} from '../utils/actionTypes';

const INITIAL_STATE = {
  value: false
};

const openMenu = (state = INITIAL_STATE, action) => {
  switch(action.type){
    case MENU_OPEN:
      return { ...state, value: true};
    case MENU_CLOSED:
      return {...state, value: false};
    default:
      return state;
  }
};

export default openMenu;


// WEBPACK FOOTER //
// ./src/reducers/menu.js